import React from 'react';
import EditHolidayForm from "./EditHolidayForm";

export default function EditHoliday(props) {

    return (
        <EditHolidayForm holiday={props.holiday} handleClose={props.handleClose}/>
    );
}
